// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"V7-z","inlineTitle":"W7-z","sponsoredAdsWrapper":"X7-z","marketplaceRecosWrapper":"Y7-z","brandShopTheLookWrapper":"Z7-z"};